const advertise = {
  dfdh: 'Téléphone de la contrepartie :',
  sjmc: 'Nom du marchand',
  qsrsj: 'Veuillez entrer le nom du marchand',
  sjbzj: 'Dépôt de garantie du marchand',
  wcl: 'Taux de complétion sur 30 jours',
  zcd: 'Total des orders (achat/vente)',
  cd: 'Orders sur 30 jours',
  c: 'fois',
  fz: 'minutes',
  pjfx: 'Délai moyen de libération',
  zcsj: 'Date d inscription :',
  fbjy: 'Première visite sur le trading fiat :',
  yxbd: 'Email vérifié',
  sjbd: 'Téléphone vérifié',
  cjsm: 'Vérification d identité niveau 1',
  gjsm: 'Vérification d identié niveau 2',
  buy: 'Acheter',
  sell: 'Vendre',
  market: 'Marché',
  djfs: 'Mode de tarification',
  ggid: 'ID de l annonce',
  time: 'Temps',
  type: 'Type',
  ptgg: 'Annonce standard',
  gdjg: 'Prix fixe',
  fdjg: 'Prix flottant',
  yjfw: 'Fourchette de prime',
  unitPrice: 'Prix unitaire',
  totalPrice: 'Prix total',
  sysl: 'Quantité restante',
  ywcsl: 'Quantité terminée',
  cz: 'Opération',
  xj: 'Désactiver',
  sj: 'Activer',
  edit: 'Modifier',
  delete: 'Supprimer',
  all: 'Tout',
  qdxjm: 'Voulez-vous vraiment désactiver cette annonce ?',
  qdxj: 'Confirmer la désactivation',
  qdsjm: 'Voulez-vous vraiment activer cette annonce ?',
  qdsj: 'Confirmer l activation',
  confirm: 'Confirmer',
  cancel: 'Annuler',
  qdscm: 'Voulez-vous vraiment supprimer cette annonce ?',
  deleteAdvertise: 'Supprimer l annonce',

  tjgm: 'Statistiques d achat',
  tjcs: 'Statistiques de vente',
  coins: 'Cryptomonnaie',
  day7: '7 jours',
  day15: '15 jours',
  day30: '30 jours',
  tj: 'Statistiques',
  mrsl: 'Quantité achetée',
  mcsl: 'Quantité vendée',
  mrjj: 'Prix moyen d achat',
  mcjj: 'Prix moyen de vente',
  zcje: 'Montant dépensé',
  srje: 'Montant reçu',
  zsxf: 'Frais totaux',
  cjdd: 'Orders exécutés',
  zdxx: 'Informations de facturation',
  tips: 'Astuce : Pour chaque paire de trading, les statistiques d achat et de vente ne peuvent être exportées que 100 fois par jour',
  dcdd: 'Exporter les orders',
  orderNo: 'Numéro d order',
  jybz: 'Cryptomonnaie de trading',
  number: 'Quantité',
  total: 'Montant total',
  fee: 'Frais',
  zd: 'Facture',

  tjskfs: 'Ajouter un mode de paiement',
  skfs: 'Mode de paiement',
  name: 'Nom',
  payAccount: 'Compte',
  sk: 'Recevoir',
  cz: 'Opération',
  delete: 'Supprimer',
  edit: 'Modifier',
  qdsc: 'Confirmer la suppression ?',
  tip: 'Astuce',
  deleted: 'Suppression annulée',
  xzskfstt: 'Ajouter un mode de paiement',
  xgskfstt: 'Modifier le mode de paiement',
  khmc: 'Nom du titulaire du compte',
  yhkh: 'Numéro de carte bancaire',
  khh: 'Banque émettrice',
  khhszd: 'Adresse de la banque émettrice',
  khhmc: 'Nom de la banque émettrice',
  wxzh: 'Compte WeChat',
  zfbzf: 'Paiement Alipay',
  ewmsc: 'Télécharger le QR code',
  jymm: 'Mot de passe de trading',
  srkhh: 'Veuillez entrer la banque émettrice',
  xzszd: 'Veuillez sélectionner l adresse de la banque émettrice',
  srkhmc: 'Veuillez entrer le nom de la banque émettrice',
  srzh: 'Veuillez entrer le numéro de compte',
  scskm: 'Veuillez télécharger le code de paiement',
  srjymm: 'Veuillez entrer le mot de passe de trading',
  scwjgd: 'La taille de l image ne doit pas dépasser 2 Mo !',

  jnbzj1: 'En tant que {gradeName}, vous avez déposé une garantie de {margin} USDT, le quota d annonce restant est de {amount} USDT',
  k: 'Peut',
  add: 'Ajouter',
  or: 'Ou',
  reduce: 'Réduire',
  margin: 'Dépôt de garantie',
  sqsxf: '*La plateforme prélève {fee}% des成交额 de l annonce en tant que frais',
  hqed: 'Devenez immédiatement un marchand certifié pour obtenir un quota plus élevé',
  want: 'Je veux',
  bb: 'Spot',
  price: 'Prix',
  ckj: '*Prix de référence du marché {price} {fiatCurrency}/USDT - Le prix fixe ne fluctuate pas avec le marché',
  jyjg: 'Prix de trading',
  mdjg: 'Prix d ancrage',
  gxhl: '*Taux de change global des banques et des échanges, mis à jour toutes les 5 minutes',
  szyj: 'Définir la prime',
  zjjy: '*Vous pouvez entrer un nombre négatif, c est-à-direuneremise par rapport au prix d ancrage',
  yjsz: '*Prix de trading = Prix d ancrage * (1 + Prime définie)',
  jyxz: 'Restrictions de trading',
  jysl: 'Quantité de trading',
  sygged: '*La quantité de trading ne peut pas dépasser le quota d annonce restant',
  zxxe: 'Montant minimum par ordre',
  zdxe: 'Montant maximum par ordre',
  fkqx: 'Délai de paiement',
  xnfk: '*Le paiement doit être effectué dans ce délai',
  fkfs: 'Mode de paiement',
  xzskfs: '*Maximum 5 modes de paiement par cryptomonnaie',
  yhjy: 'Ne pas trader avec les utilisateurs n ayant pas terminé la vérification d identité niveau 2',
  jygg: '*Les utilisateurs n ayant terminé que la vérification niveau 1 ne peuvent pas publier d annonces',
  cyjy: 'Veuillez sélectionner les utilisateurs n ayant pas terminé le nombre d achats requis',
  bmfx: '*Les utilisateurs ayant effectué des achats ont un risque réduit de fonds d origine douteuse',
  qxz: 'Veuillez sélectionner',
  jybz: 'Notes de trading',
  tyzs: 'J ai lu et j accepte de respecter',
  jygz: '« Règles de trading »',
  yzm: 'Code de vérification',
  save: 'Enregistrer',
  fbgg: 'Publier l annonce',
  jsbzjcg: 'Réduction du dépôt de garantie réussie',
  zjbzjcg: 'Augmentation du dépôt de garantie réussie',
  xzfs: 'Veuillez sélectionner un mode de paiement',
  bankTip1: 'Les cartes bancaires ne peuvent pas dépasser 3 modes de paiement',
  wxTip2: 'WeChat ne peut pas dépasser 3 modes de paiement',
  zfbTip3: 'Alipay ne peut pas dépasser 3 modes de paiement',
  syjg: 'Veuillez entrer le prix',
  syjysl: 'Veuillez entrer la quantité de trading',
  zxxe: 'Veuillez entrer le montant minimum par ordre',
  zdxe: 'Veuillez entrer le montant maximum par ordre',
  fkqx: 'Veuillez entrer le délai de paiement',
  tyjygz: 'Veuillez accepter les règles de trading',
  tpyzm: 'Veuillez entrer le code de vérification d image',
  jydx: 'Contrepartie de trading',

  zjbzj: 'Augmenter le dépôt de garantie',
  jsbzj: 'Réduire le dépôt de garantie',
  xzdgged: 'Quota d annonce actuel maximum',
  zjbzjse: 'Montant à ajouter au dépôt de garantie',
  jsbzjse: 'Montant à réduire du dépôt de garantie',
  zjhbzjed: 'Montant du dépôt après augmentation',
  jshbzjed: 'Montant du dépôt après réduction',
  balance: 'Solde',
  sy: 'Restant',
  kzj: 'Peut ajouter',
  kjs: 'Peut réduire',
  otcsjxy: 'Accord des règles de service pour les marchands OTC',
  xsgz: 'Tutoriel pour débutants',
  jygz: 'Règles de trading',
  jnbzj: 'Pour garantir la légalité et la conformité de l OTC, les marchands doivent déposer un montant de garantie ;',
  zjjnbzj: 'Le dépôt de garantie se compose de deux parties : le montant de base (obligatoire) et le montant supplémentaire (optionnel) ;',
  kxs: 'En déposant le montant de base, vous bénéficiez',
  fbgged: 'Le quota d annonce (calculé au taux de change pour les anuncios en CNYT) ;',
  ggedbl: 'Le ratio entre le dépôt supplémentaire et le quota d annonce est de',
  eg: 'Par exemple, ajouter 100 USDT augmente le quota d annonce de 100 x',
  ggzedjs: 'La formule du quota total d annonce : Quota de base + Quota supplémentaire x',
  ttsjzxed: 'Le montant minimum de dépôt supplémentaire pour un marchand standard est',
  zdedw: 'Le montant maximum est',
  mgsjzd: 'Chaque marchand peut publier au maximum 3 annonces d achat et 3 annonces de vente.',
  hljj: 'Le taux de change USDT/CNYT est basé sur le prix moyen des 24 dernières heures de la paire de trading sur BiKing (enregistré chaque heure, avec suppression des prix les plus hauts et les plus bas) ; lorsque le taux fluctue, le quota des annonces publiées reste inchangé.',
  jcbzj: 'Dépôt de base',
  xt: 'Optionnel',
  njhded: 'Le quota d annonce que vous obtenu est de :',
  mbye: 'Solde d achat de crypto :',
  zhzcbz: 'Les actifs du compte sont insuffisants, vous pouvez transférer depuis le compte des actifs',
  qhz: 'Transférer',
  qdjnbzj: 'Confirmer le dépôt de garantie de base',
  tjbzj: 'Ajouter un dépôt de garantie',
  sqsjcg: 'Demande de marchand réussie',
  exchange: 'Changement de taux'
}
export {
    advertise
}


// WEBPACK FOOTER //
// ./src/i18n/lang/advertise/fr.js